import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={(props) => (
      sessionStorage.getItem('purecloud-csp-token')
        ? <Component {...props} />
        : <Redirect to='/login' /> //change to : <Redirect to='/login' />
    )} />
  )
}

export default PrivateRoute